export default "__VITE_ASSET__COCj_1GT__"